/* src/app/venue-filters/venue-filters.component.scss */
.mat-mdc-menu-item.mdc-list-item {
  align-items: center;
  padding-top: 5px;
  padding-bottom: 5px;
}
/*# sourceMappingURL=venue-filters.component.css.map */
